import React, {useState} from 'react'
import {Link, Navigate, useLocation} from 'react-router-dom'

// Assets
import Logo from '../../assets/images/logo.png'
import LoginImage from '../../assets/images/login-image.jpg'

// Components
import InputField from '../elements/InputField'
import Button from '../elements/Button'
import SocialMediaButtons from "./SocialMediaButtons";

//API
import {authenticationService} from '../../api'

const loginDestinations = {
    "/": {
        eyebrow: "ChampionBred platform",
        description: "Analyse pedigrees, explore auction catalogues and keep your breeding research together.",
    },
    "/membership": {
        eyebrow: "Continue to membership",
        description: "Sign in to view membership options and manage the credits used for your reports.",
    },
    "/pedigree-analysis": {
        eyebrow: "Continue to pedigree analysis",
        description: "Sign in to view your pedigree reports and continue your breeding research.",
    },
    "/catalogues": {
        eyebrow: "Continue to auction catalogues",
        description: "Sign in to explore analysed horses from current thoroughbred auctions.",
    },
    "/premium": {
        eyebrow: "Continue to premium reports",
        description: "Sign in to compare more breeding combinations and manage larger requests.",
    },
    "/my-lists": {
        eyebrow: "Continue to horse lists",
        description: "Sign in to organise and revisit the sires and dams you are researching.",
    },
}

export function getLoginDestination(pathname) {
    return loginDestinations[pathname] || {
        eyebrow: "ChampionBred platform",
        description: "Sign in to continue your pedigree analysis and breeding research.",
    }
}

function LoginCard() {
    const [redirect, setRedirect] = useState(false)
    const [errors, setErrors] = useState({})
    const location = useLocation()
    const requestedLocation = location.state?.from
    const destination = requestedLocation
        ? `${requestedLocation.pathname}${requestedLocation.search || ""}${requestedLocation.hash || ""}`
        : "/"
    const loginDestination = getLoginDestination(requestedLocation?.pathname || "/")

    function handleSubmit(e) {
        e.preventDefault()

        var form_element = document.getElementById('login-form')
        var form_data = new FormData(form_element)

        authenticationService.login(form_data)
            .then(response => {
                setRedirect(true)
            })
            .catch(error => {
                setErrors({...error})
            })
    }

    if (redirect) {
        return <Navigate to={destination}/>
    }

    return (
        <div className="reg-card login-card half-width screen-center full-mobile">
            <div className="flexer flexer-spaced flexer-mobile">
                <div className="flexer-5 center login-card__form-panel">
                    <Link to="/" aria-label="Visit the ChampionBred home page">
                        <img className="one-third-width mt-30 mb-20" src={Logo} alt="ChampionBred"/>
                    </Link>
                    <p className="login-card__eyebrow">{loginDestination.eyebrow}</p>
                    <div className="mx-10"><h1 className="huge-letters is-black line-margin-0"><span
                        className="is-bold">welcome</span> back</h1></div>
                    <p className="subtext login-card__description px-30">{loginDestination.description}</p>
                    <form id="login-form" className="my-20 mx-20" onSubmit={handleSubmit}>
                        <InputField name="email" type="email" label="Email" error={errors.email}/>
                        <InputField name="password" type="password" label="Password"
                                    error={errors.password || errors.non_field_errors || errors.detail}/>
                        <p className="line-margin-0 right"><Link className="subtext link is-gold" to="/forgot-password">Forgot
                            password?</Link></p>
                        <Button text="Sign in" class="half-width mt-30" type="submit"/>

                        <SocialMediaButtons type="login" redirectPath={destination}/>
                    </form>
                    <p className="subtext is-black login-card__signup">New to ChampionBred?&nbsp;
                        <Link className="link is-gold" to="/signup">Sign up free and get 10 tokens</Link>
                    </p>
                </div>
                <img className="half-width full-mobile login-card__image" src={LoginImage} alt="Racehorse with the message Helping you find the best horse"/>
            </div>
        </div>
    )
}

export default LoginCard
